import _css from '../scss/styles.scss';
import './foundation/foundation-explicit-pieces';
import 'owl.carousel2';
import Menu from './ins/menu';
import './ins/page-produit';
import './ins/affiner-recherche';
import './ins/multi-langues';
import './ins/promo';
import './ins/bigGrid';

$(document).foundation();
import './ins/Sliders';

$(document).ready(()=>{
  const menu = new Menu();
  menu.init()

  /* Ouverture / fermeture du bloc de recherche */
  $('#search-btn').on('click', () => {
    $('.header__search--form').toggleClass('is--open');
  });
});

